import { render, staticRenderFns } from "./indexnr.vue?vue&type=template&id=6f29f9a3&"
import script from "./indexnr.vue?vue&type=script&lang=js&"
export * from "./indexnr.vue?vue&type=script&lang=js&"
import style0 from "./indexnr.vue?vue&type=style&index=0&id=6f29f9a3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports